/**
 *
 * TreatmentList
 *
 */
import { Component } from "react";
import * as PropTypes from "prop-types";
import TreatmentQuestions from "./TreatmentQuestions";

class TreatmentList extends Component {
  static propTypes = {
    treatments: PropTypes.array.isRequired,
    treatment: PropTypes.object,
    onActiveChanged: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onExtraTreatment: PropTypes.func.isRequired,
    wagnerItem: PropTypes.any,
    wagnerActive: PropTypes.bool,
    screenWidth: PropTypes.bool,
    onDisableWagner: PropTypes.func.isRequired,
  };

  static defaultProps = {
    treatment: null,
  };

  handleSkip = (treatment, index) => {
    if (!treatment.active) {
      this.props.onDisableWagner();
    }

    const newIndex = index + 1;

    if (newIndex >= this.props.treatments.length) {
      // When skipping the last treatment
      return;
    }

    // Set the new active
    this.props.onActiveChanged(this.props.treatments[newIndex], newIndex);
  };

  handlePrevious = (treatment, index) => {
    if (!treatment.active) {
      this.props.onDisableWagner();
    }

    const newIndex = index - 1;

    if (newIndex < 0 || newIndex >= this.props.treatments.length) {
      // New index out of bounds.
      return;
    }

    // Set the new active
    this.props.onActiveChanged(this.props.treatments[newIndex], newIndex);
  };

  handleEdit = (treatment, index) => {
    this.props.onEdit(treatment, index);
  };

  render() {
    const treatments = this.props.treatments.slice();
    let activeId = -1;
    if (this.props.treatment) {
      activeId = this.props.treatment.id;
    }

    return (
      <TreatmentQuestions
        onPrevious={this.handlePrevious}
        treatments={treatments.slice()}
        activeId={activeId}
        onDelete={this.props.onDelete}
        onSkip={this.handleSkip}
        onEdit={this.handleEdit}
        onExtraTreatment={this.props.onExtraTreatment}
        wagnerItem={this.props.wagnerItem}
        wagnerActive={this.props.wagnerActive}
        screenWidth={this.props.screenWidth}
      />
    );
  }
}

export default TreatmentList;
